import { Map, GoogleApiWrapper, Polyline } from 'google-maps-react';
import { Component, useEffect, useState } from 'react';
import createPolyLine from './createPolyLine';
import React, { useRef } from 'react';
import { useMediaQuery } from 'react-responsive';
import decodeLevels from './DecodeLevels';
import decodePolyline from 'decode-google-map-polyline';

const HomeMap = ({ google }) => {
  const [selectedRide, setSelectedRide] = useState('');
  const [selectedRidePolyline, setSelectedRidePolyline] = useState('');

  const userData = JSON.parse(sessionStorage.getItem('UserData'));
  let userRides = userData.rides;
  useEffect(() => {
    setSelectedRide(JSON.parse(sessionStorage.getItem('choiceRideId')));
    setSelectedRidePolyline(
      JSON.parse(sessionStorage.getItem('choiceRidePolyline'))
    );
  }, [userData]);

  const mapRef = useRef(null);

  useEffect(() => {
    if (selectedRidePolyline && mapRef.current) {
      const decodedPolyline = decodePolyline(selectedRidePolyline);
      const bounds = new google.maps.LatLngBounds();

      decodedPolyline.forEach((point) => {
        bounds.extend(new google.maps.LatLng(point.lat, point.lng));
      });

      mapRef.current.map.fitBounds(bounds);
    }
  }, [selectedRidePolyline]);

  const mapStyle = {
    width: 'calc(100% - 400px)',
    height: 'calc(100% - 80px)',
    left: '0px',
    overFlow: 'hidden',
  };

  const mapStyle2 = {
    width: '100%',
    height: 'calc(100% - 50px)',
    left: '0px',
    top: '50px',
    zIndex: '1',
    overFlow: 'hidden',
  };

  const isPc = useMediaQuery({
    query: '(min-width: 768px)',
  });

  const handleRideClick = (rideId) => {
    const selectedRide = userRides.find((ride) => ride.rideId === rideId);
    if (selectedRide && selectedRide.summary_polyline) {
      setSelectedRide(rideId);
      setSelectedRidePolyline(selectedRide.summary_polyline);
    }
  };

  return (
    <div>
      <Map
        containerStyle={isPc ? mapStyle : mapStyle2}
        google={google}
        zoom={7}
        initialCenter={{ lat: 36.86852, lng: 127.755139 }}
        mapTypeId={google.maps.MapTypeId.TERRAIN}
        styles={[
          {
            stylers: [
              {
                saturation: -50,
              },
            ],
          },
          {
            elementType: 'geometry.stroke',
            stylers: [
              {
                visibility: 'simplified',
              },
              {
                weight: 1,
              },
            ],
          },
        ]}
        ref={mapRef}
      >
        {selectedRide === '' ||
        selectedRide === null ||
        selectedRide === undefined ||
        selectedRide === NaN
          ? userRides
              .filter((realPath) => realPath.summary_polyline != null)
              .map((it) => createPolyLine(it, handleRideClick))
          : userRides
              .filter((realPath) => realPath.summary_polyline != null)
              .filter((realPath) => realPath.rideId === selectedRide)
              .map((it) => createPolyLine(it, handleRideClick))}
      </Map>
    </div>
  );
};

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
})(HomeMap);
